export const shortenAddress = (address: string, divisor = `___`) => {
  return address?.replace(address.substring(5, address.length - 3), divisor)
}
